import {
    whiteColor,
    primaryColor,
    secondaryColor,
    warningColor,
    infoColor
} from "assets/jss/material-dashboard-react.js";


const drawerWidth = 240;
const styles = theme => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        //  justifyContent: 'space-between',
        ...theme.mixins.toolbar
    },
    muiToolbarDense: {
        minHeight: 50
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,

    },

    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: whiteColor,
        color: secondaryColor[1],
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    bottomNavigation: {
        backgroundColor: 'transparent',
        marginLeft: 'auto',
        marginRight: 'auto',
        alignItems: 'flex-start'
    },
    bottomNavigationActionRoot: {
        minWidth: 90
    },
    buttonNavigationAction: {
        color: 'inherit'
    },
    buttonNavigationsSelected: {
        color: `${infoColor[0]} !important`
    },
    menuButton: {
        marginLeft: 12,
        marginRight: 12,

    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        fontWeight: 'bold',
        position: 'absolute'

    },
    title1: {
        color: "white"
    },
    avatarsmall: {
        width: theme.spacing(3.5),
        height: theme.spacing(3.5),
    },
    logoDiv: {
        position: "absolute",
        height: '50px',
        top: '0'
    },
    imageStyle: {
        height: "inherit"
    },

    actionLabel: {
        fontSize: '0.75rem !important'
    },
    muiIconRoot: {
        width: '2.5em !important'
    },
    rightIconContainer: {
        position: "absolute",
        height: '50px',
        top: 5,
        right:15,
        display:'flex'
    },
    svgIconRoot: {
        width: '1.2em !important',
        height: '1.2em !important'
    },

    iconnNotificationsButton: {
        color: primaryColor[0],
        padding: 5
    },
    
    iconbqbnseButton: {
        color: warningColor[0],
        padding: 5
    },

    userNameText: {
        fontWeight: 'bold',
        maxWidth: '10rem',
        lineHeight: 1,
        marginRight: 2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        // height: '3em',
        '-webkit-line-clamp': '1',
        '-webkit-box-orient': 'vertical',
        [theme.breakpoints.down('xs')]: {
            maxWidth: '5rem',
        },
    }
    


});

export default styles;
